 <button
  class="wk-button wk-button-icon wk-button-icon-large"
  (click)="openChat()"
>
  <span
    class="wk-icon-filled-chat-box">
  </span>
  <span class="wk-sr-only">Search</span>
</button>
